var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBuzzerBold = function SvgIconBuzzerBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M4.156 18.83h15.689-.014v-2h.014-15.69.015v2zm4.113-6.65h2.367V9.959q0-.587.397-1.004.396-.417.967-.417V6.17q-1.565 0-2.648 1.112T8.269 9.958zm-1 2h9.463V9.959q0-1.977-1.378-3.382T12 5.17 8.646 6.576Q7.27 7.98 7.27 9.958zm-3.1 7.3a2.56 2.56 0 0 1-1.878-.77 2.56 2.56 0 0 1-.771-1.88v-2q0-1.107.77-1.878a2.56 2.56 0 0 1 1.88-.771h.449V9.958q0-3.095 2.147-5.267Q8.914 2.52 11.997 2.52q3.084 0 5.234 2.171 2.15 2.172 2.15 5.267v4.223h.45q1.107 0 1.878.77.771.772.771 1.88v2q0 1.107-.77 1.878a2.56 2.56 0 0 1-1.88.771z"
  })));
};
export default SvgIconBuzzerBold;